import React from 'react'
import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { BASE_URL } from '../../Environment'
import { updateLocalStorage } from '../../stores/PublicPatient/Auth'
import Loader from 'react-loader-spinner'

const RedirectPending = () => {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(location.search)
    const id = urlSearchParams.get('id') || ''
    const token = urlSearchParams.get('token') || ''

    if (id.length > 0 && token.length > 0) {
      localStorage.setItem('patient_user_id', id)
      localStorage.setItem('patient_auth_key', token)
      fetch(new URL('patient/patient-account-list', BASE_URL), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token
        },
        body: JSON.stringify({
          user_id: id,
          table_config_rows_per_page: '1',
          table_config_page_no: '1'
        })
      })
        .then(res => res.json())
        .then(json =>
          updateLocalStorage({
            user: {
              id_token: token,
              user_id: id,
              self_patient_data: json.response?.[0] ?? {}
            }
          })
        )
        .then(() => window.location.replace('/patient/appointments'))
        .catch(console.error)
    } else alert('Bad Redirection')
  }, [location.search, history])

  return (
    <Loader
      type="ThreeDots"
      color="#114ebd"
      height={75}
      width={75}
      timeout={0}
      style={{ marginLeft: '40%' }}
    />
  )
}

export default RedirectPending
